import { FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export const createOneAndOnlyOneSatisfiesConditionValidator = <TFormArrayMemberControlValue>(
  conditionToSatisfy: (value: TFormArrayMemberControlValue | null) => boolean,
  enforceWhenArrayEmpty: boolean,
  multipleSatisfiesErrorKey?: string,
  noneSatisfiesErrorKey?: string
): ValidatorFn => {
  const oneAndOnlyOneSatisfiesConditionValidator: ValidatorFn = (control: FormArray) => {
    let conditionSatisfied = false;
    for (let i = 0; i < control.length; i++) {
      const currentValue = control.at(i).value as TFormArrayMemberControlValue | null;
      if (conditionToSatisfy(currentValue)) {
        if (conditionSatisfied) {
          const error: ValidationErrors = {};
          error[multipleSatisfiesErrorKey || 'multipleSatisfiedCondition'] = true;
          return error;
        }
        conditionSatisfied = true;
      }
    }
    if (!conditionSatisfied) {
      if (control.length === 0 && !enforceWhenArrayEmpty) {
        //special case, don't enforce
        return null;
      }
      const error: ValidationErrors = {};
      error[noneSatisfiesErrorKey || 'noneSatisfiedCondition'] = true;
      return error;
    }
    return null;
  };

  return oneAndOnlyOneSatisfiesConditionValidator;
};
